import { render, staticRenderFns } from "./FormBusiness.vue?vue&type=template&id=69e2d31e&scoped=true&"
import script from "./FormBusiness.vue?vue&type=script&lang=js&"
export * from "./FormBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e2d31e",
  null
  
)

export default component.exports